
import { StyleSheet } from "react-native"

const styles = StyleSheet.create({
    grid: {
        flexDirection: "row",
        flexWrap: "wrap"
    }
})
export default styles;